<template>
    <header class="header" v-if="$route.path !== '/award/awardCode'">
        <div class="icon-box">
<!--          <button v-if="$route.path !== '/mobile' && $route.path !== '/emarticon/emarticonQuestionsWeb'"-->
<!--                  class="icon-header-left" @click="goBack" title="뒤로가기"></button>-->
<!--          <button v-if="$route.path !== '/mobile' && $route.path !== '/emarticon/emarticonQuestionsWeb'"-->
<!--                  class="icon-left-arrow" @click="goBack" title="뒤로가기">-->
          <button v-if="$route.path !== '/mobile' && $route.path !== '/emarticon/emarticonQuestionsWeb'"
                  @click="goBack" title="뒤로가기">
            <img src="@/assets/images/home_back.png" alt="" />
          </button>
          <button v-if="$route.path !== '/award/awardCode'" type="button" @click="goHome" title="홈">
            <img src="@/assets/images/icon-home-241107.png" alt="" />
<!--            <button v-if="$route.path !== '/mobile' && $route.path !== '/emarticon/emarticonQuestionsWeb'" class="icon-left-arrow" @click="goBack" title="뒤로가기">-->
<!--            </button>-->
<!--            <button v-if="$route.path !== '/award/awardCode'" type="button" class="icon-home" @click="goHome" title="홈">-->
            </button>
        </div>
        <div><h1 class="header-title">{{ this.text }}</h1></div>
        <div class="icon-box">
<!--            <button class="icon-search" title="검색"></button>-->
<!--            <button class="icon-menu" title="네비게이션메뉴"></button>-->
        </div>
    </header> 
</template>
    
<script>
export default {
  name: "TopHeader",
  props : {
    text: String,
  },
  methods: {
      goBack() {
        console.log("location ", window.location.pathname);
        console.log("location ", this.$route.path);
        if (this.$route.path === '/myemarticon/setting') {
          this.$router.push({name: 'home'});
        } else if (this.$route.path === '/myemarticon/password') {
          this.$router.push({name: 'setting'});
        } else if (this.$route.path !== '/home') {
          window.history.back();
        } else {
          window.location.replace(process.env.VUE_APP_EMART_SITE_NOWTRDEL);
        }
        // else {
        //   const mobile = (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));
        //
        //   if (mobile) {
        //     window.location.replace(process.env.VUE_APP_EMART_SITE_NOWTRDEL);
        //   }else{
        //     window.history.back();
        //   }
        // }
      },
      goHome() {
        // Todo 안드로이드 뒤로가기 제어
        if (this.$store.state.nativeStore.device === "and") {
          window.location.href = 'emart-today://goback/?enable=Y'; // 뒤로가기 허용
        }

        window.location.replace(process.env.VUE_APP_EMART_SITE_NOWTRDEL);
        // if (this.$route.path !== '/home') {
        //   this.$router.push({name:'home'})
        // }
      }
  }
}   
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/layout/header.scss'; 
</style>